/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ExternalVoucherPendingCountOut } from '../models/ExternalVoucherPendingCountOut';
import type { ExternalVoucherStatus } from '../models/ExternalVoucherStatus';
import type { OrderData } from '../models/OrderData';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ExternalVoucherService {
  /**
   * Get Pending Count
   * @returns ExternalVoucherPendingCountOut Successful Response
   * @throws ApiError
   */
  public static getExternalVoucherPendingCount(): CancelablePromise<ExternalVoucherPendingCountOut> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/external_voucher/pending_count',
    });
  }

  /**
   * Get Redemptions
   * @param page Page number
   * @param perPage Items per page
   * @param search Search by name, email, phone, order number or voucher code
   * @param statuses Filter by redemption status
   * @returns OrderData Successful Response
   * @throws ApiError
   */
  public static getExternalVoucherRedemptions(
    page: number = 1,
    perPage: number = 10,
    search?: string,
    statuses?: Array<ExternalVoucherStatus>,
  ): CancelablePromise<Array<OrderData>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/external_voucher/redemptions',
      query: {
        page: page,
        per_page: perPage,
        search: search,
        statuses: statuses,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Verify
   * @param orderId
   * @returns OrderData Successful Response
   * @throws ApiError
   */
  public static verifyExternalVoucher(orderId: string): CancelablePromise<OrderData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/external_voucher/verify',
      query: {
        order_id: orderId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }

  /**
   * Reject
   * @param orderId
   * @returns OrderData Successful Response
   * @throws ApiError
   */
  public static rejectExternalVoucher(orderId: string): CancelablePromise<OrderData> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/external_voucher/reject',
      query: {
        order_id: orderId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
